import { RecommendationReasonType } from "stash/components/retirement/managed/Recommendation/TaxInformationSheet";
import { BlockedRetirementAccountDetails, RecommendationAccountType, RetirementAccountDetails } from "stash/components/retirement/managed/Recommendation/types";
import type { RolloverIraOpeningContext } from "stash/components/retirement/rollover/rolloverIraOpeningSession";

export type RetireState = {
	annualIncome?: number;
	age?: number;
	currentRetirementAccountDetails?: RetirementAccountDetails;
	recommendationAccountType?: RecommendationAccountType;
	recommendationReasoning?: RecommendationReasonType;
	blockedRetirementAccountTypes?: BlockedRetirementAccountDetails[];
	/** When true, PX confirm/questions continue into secondary selection (STASH2026-13628). */
	isSecondaryIraOpening?: boolean;
	/**
	 * Non-closed retirement account count at open-entry time (STASH2026-13632).
	 * Stamped on create_account product events as `existing_ira_count`.
	 */
	existingIraCount?: number;
	/** Set only while the current opening was started by a rollover handoff. */
	rolloverIraOpening?: RolloverIraOpeningContext;
};

export const SET_RETIRE_STATE = 'SET_RETIRE_STATE';

export const setRetireState = (state: Partial<RetireState>) => ({
	type: SET_RETIRE_STATE,
	payload: state,
});
